import { Stack, Group, Box } from '@mantine/core';
import { AfaModal, AfaButton, AfaDropzone,AfaTextarea } from '../../ui';
import ApiService from '../../../utils/ApiService';
import { useState } from 'react';
import { notifications } from '@mantine/notifications';
import { convertToBase64 } from '../../../utils/Utils';
import { useNavigate } from 'react-router-dom';

interface UploadDocumentacioTramitModalProps {
  apiService: ApiService;
  opened: boolean;
  onClose: () => void;
  tramitId: any;
  tramitState: any;
  entityId: any;
}

export function UploadDocumentacioTramitModal({ apiService, opened, onClose, tramitId,tramitState, entityId }: UploadDocumentacioTramitModalProps) {

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<Array<{ file: File; name: string; type: 'pdf' | 'doc' | 'xls' | 'ppt' | 'png' | 'jpg' | 'other' }>>([]);
  const [getComentarisValue, setComentarisValue] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setIsSubmitting(true);
    e.preventDefault();
    let prefix = "01_";
    switch(tramitState)
    {
      case "Pendent rebre documentació":
        prefix = "01_";
        break;

      case "Pendent rebre pagament":
        prefix = "06_";
        break;
    }
    const docs = await Promise.all(
      uploadedFiles.map(async (item) => {
        const base64 = await convertToBase64(item.file);
        return {
          title: prefix + item.name,
          content: base64.split(",")[1],
        };
      })
    );

    let fase  = "Validació i Anàlisi"; 
    switch(tramitState)
    {
      case "Pendent rebre documentació":
        fase = "Validació i Anàlisi";
        break;

      case "Pendent rebre pagament":
        fase = "Validació taxes o pagament";
        break;
    }

    const dataForm = {
      state: "En revisió",
      EntitatId : entityId,
      docs,
      comments: getComentarisValue,
      fase
    };

    apiService.UpdateTramit(tramitId, dataForm)
      .then((result: any) => {
        if (result.statusText === "OK") {
          notifications.show({
            title: "Tràmit actualitzat",
            message: "El tràmit s'ha actualitzat correctament",
            color: "teal",
          });
          
          const data = result.data;

          navigate(`/tramits/editar/${data.itemId}`, {
            state: {
              fromUploadDocs: true,
              pdf: data.document?.fileContents ?? null,
              codi: data.itemGuid
            }
          });

        } else {
          notifications.show({
            title: "Error",
            message: result.message || "S'ha produït un error inesperat.",
            color: "red",
          });
        }
      })
      .catch((error: any) => {
        setIsSubmitting(false);
        notifications.show({
          title: "Error",
          message: error.message || "S'ha produït un error inesperat.",
          color: "red",
        });
      })
  };

  const handleClose = () => {
    onClose();
  };

  const getFileExtension = (filename: string): string | null => {
    const cleanName = filename.trim();

    const lastDotIndex = cleanName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === cleanName.length - 1) {
      return null;
    }

    return cleanName.substring(lastDotIndex + 1).toLowerCase();
  };

  return (
    <AfaModal
      opened={opened}
      onClose={handleClose}
      title="Pujar documentació"
      size="lg"
      centered
    >
      <form onSubmit={handleSubmit}>
        <Stack mt="sm" gap="md">
          <Box mt="xs">
            <AfaDropzone
              onDrop={(files) => {
                const newFiles = files.map(file => {
                  //const extension = file.name.split('.').pop()?.toLowerCase();
                  const extension = getFileExtension(file.name);

                  let type: 'pdf' | 'doc' | 'xls' | 'ppt' | 'png' | 'jpg' | 'other' = 'other';

                  if (extension === 'pdf') type = 'pdf';
                  else if (extension === 'doc' || extension === 'docx') type = 'doc';
                  else if (extension === 'xls' || extension === 'xlsx') type = 'xls';
                  else if (extension === 'ppt' || extension === 'pptx') type = 'ppt';
                  else if (extension === 'png') type = 'png';
                  else if (extension === 'jpg' || extension === 'jpeg') type = 'jpg';

                  return { file, name: file.name, type };
                });

                setUploadedFiles(prevFiles => [...prevFiles, ...newFiles]);
              }}
              uploadedFiles={uploadedFiles}
              onDeleteFile={(_, index) => {
                const newFiles = uploadedFiles.filter((_, i) => i !== index);
                setUploadedFiles(newFiles);
              }}
            />
          </Box>

          <AfaTextarea
            id="comentaris"
            name="comentaris"
            label="Comentaris"
            placeholder="Escriure aquí"
            autosize
            minRows={3}
            maxRows={6}
            value={getComentarisValue}
            onChange={(e) => setComentarisValue(e.target.value)}
            />
          <div style={{ flex: 1 }}></div>

          <Group justify="flex-end">
            <AfaButton
              id="btn-cancelar-ara"
              variant="filled"
              // color="red"
              type="submit"
              loading={isSubmitting}
            >
              Enviar
            </AfaButton>
          </Group>
        </Stack>

      </form>
    </AfaModal>
  );
}
